const initalstate = {
    BrowsersData:[],
    share:[]
};

export default initalstate;